// extracted by mini-css-extract-plugin
export default {"referenced_documents_label":"UcG88ELcAgDnokOiVL_Q","referenced_documents_trigger":"PqroWTCwnWITdeysmy6n"};